// Calculate totals from lvs data recursively
export const calculateTotals = (elements) => {
	if (!elements) return { groups: 0, positions: 0, amount: 0 };

	let totalGroups = 0;
	let totalPositions = 0;
	let totalAmount = 0;

	elements.forEach((element) => {
		if (element.isGroup) {
			totalGroups += 1;
			const subTotals = calculateTotals(element.elements);
			totalGroups += subTotals.groups;
			totalPositions += subTotals.positions;
			totalAmount += subTotals.amount;
		} else {
			totalPositions += 1;
			totalAmount += element.totalPrice || element.totalPriceGross || 0;
		}
	});

	return {
		groups: totalGroups,
		positions: totalPositions,
		amount: totalAmount,
	};
};

// Get all group IDs recursively
export const getAllGroupIds = (elements) => {
	const groupIds = new Set();
	if (!elements) return groupIds;

	elements.forEach((element) => {
		if (element.isGroup) {
			groupIds.add(element.id);
			const subGroupIds = getAllGroupIds(element.elements);
			subGroupIds.forEach((id) => groupIds.add(id));
		}
	});

	return groupIds;
};

// Additional aufmass-specific helper functions can be added here
// For example, functions to handle measurement data, calculate measured quantities, etc.

/**
 * Calculate measured quantities for positions
 * @param {Array} positions - Array of position objects
 * @returns {Object} - Object with measured totals
 */
export const calculateMeasuredTotals = (positions) => {
	if (!positions) return { measuredQuantity: 0, measuredAmount: 0 };

	let totalMeasuredQuantity = 0;
	let totalMeasuredAmount = 0;

	positions.forEach((position) => {
		const measuredQty = position.aufmass?.quantity || 0;
		totalMeasuredQuantity += measuredQty;

		if (position.unitPrice) {
			totalMeasuredAmount += position.aufmass?.amount || 0;
		}
	});

	return {
		measuredQuantity: totalMeasuredQuantity,
		measuredAmount: totalMeasuredAmount,
	};
};

/**
 * Get all position IDs from hierarchical data recursively
 * @param {Array} elements - Array of hierarchical elements
 * @returns {Set} - Set of position IDs
 */
export const getAllPositionIds = (elements) => {
	const positionIds = new Set();
	if (!elements) return positionIds;

	elements.forEach((element) => {
		if (element.isGroup) {
			const subPositionIds = getAllPositionIds(element.elements);
			subPositionIds.forEach((id) => positionIds.add(id));
		} else {
			positionIds.add(element.id);
		}
	});

	return positionIds;
};
